import {Component, Input, OnInit} from '@angular/core';
import {BranchDaySupplyStruct} from "./DaysSupplyStruct";
import {BranchConstant, BranchMeasurement} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-branch-type-day-supply-overview-component',
  templateUrl: './branch-type-day-supply-overview.component.html',
  styleUrls: ['./branch-type-day-supply-overview.component.css']
})
export class BranchTypeDaySupplyOverviewComponent implements OnInit {
  @Input() branchDaySupplyOverview: BranchDaySupplyStruct | undefined;

  startprogram: &VariableValue = new VariableValue();
  silolevel: &VariableValue = new VariableValue();
  nrruntoday: &VariableValue = new VariableValue();

  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  constructor(private variableDB: VariableDataBase) { }

  ngOnInit(): void {
    if( this.branchDaySupplyOverview ) {
      this.startprogram = this.variableDB.AddValueByReference(this.branchDaySupplyOverview.startprogram.variable.id);
      this.silolevel = this.variableDB.AddValueByReference(this.branchDaySupplyOverview.silolevel.variable.id);
      this.nrruntoday = this.variableDB.AddValueByReference(this.branchDaySupplyOverview.nrruntoday.variable.id);
    }
  }

}
